<template>
   <div class="Home">
       <loader v-show="loader"/>
       <masternav/>
    </div>
</template>

<script>
import masternav        from '@/components/masternav.vue'
import loader           from '@/components/loader.vue'
import { mapState }     from 'vuex'

    export default {
        components: {
            loader,
            masternav
        },
        computed: {
            ...mapState('autenticacion', ['loader'])
        },
    }
</script>

<style lang="scss" scoped>

</style>